import React from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import ModalFormWrapper from './ModalFormWrapper.js';

class MenuEditElementForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {title: this.props.menuElement.content.title};
        this.handleChange = this.handleChange.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        this.setState({title: e.target.value});
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.handleSubmit({title: this.state.title});
    }

    handleCancel(e) {
        this.props.handleCancel();
    }

    render() {
        return (
            <ModalFormWrapper
                handleCancel={this.handleCancel}
                handleSubmit={this.handleSubmit}
                title='Edit menu element'
                content={
                    <>
                        <InputGroup className='mb-3'>
                            <InputGroup.Text id='add-title'>Title</InputGroup.Text>
                            <FormControl
                                type='text'
                                aria-describedby='add-title'
                                name='title'
                                value={this.state.title}
                                onChange={this.handleChange}
                            />
                        </InputGroup>
                    </>
                }
                buttons={
                    <>
                        <Button variant='danger' onClick={this.handleCancel}>Cancel</Button>
                        <Button type='submit' variant='success'>Update</Button>
                    </>
                }
            />
        );
    }
}

export default MenuEditElementForm;
